<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="dialog-container">
        <el-radio
          v-model="formData.type"
          label="1">
          <span class="type-span">Today</span>
        </el-radio>
        <el-radio
          v-model="formData.type"
          label="2">
          <span class="type-span">Period</span>
          <v-date-picker
            v-model="formData.date"
            type="daterange"
            @focus="dateFocus('Period')"></v-date-picker>
        </el-radio>
        <el-radio
          v-model="formData.type"
          label="3">
          <span class="type-span">Monthly</span>
          <el-date-picker
            v-model="formData.month"
            :format="'yyyy-MM'"
            :value-format="'yyyy-MM'"
            type="month"
            @focus="dateFocus('month')"></el-date-picker>
        </el-radio>
        <el-radio
          v-model="formData.type"
          label="4">
          <span class="type-span">Year</span>
          <el-date-picker
            v-model="formData.year"
            :format="'yyyy'"
            :value-format="'yyyy'"
            type="year"
            @focus="dateFocus('year')"></el-date-picker>
        </el-radio>
        <!--      <span-->
        <!--        slot="footer"-->
        <!--        class="dialog-footer">-->
        <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--        <el-button-->
        <!--          type="primary"-->
        <!--          @click="dialogVisible = false">确 定</el-button>-->
        <!--      </span>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'dashboardSearch',
  data() {
    return {
      dialogVisible: false,
      formData:{
        type:'1',
        date:'',
        month:'',
        year:''
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialogVisible = !this.dialogVisible
    },
    handleClose() {
      this.dialogVisible =false
      console.log('this.formData',this.formData)
      this.$emit('handlerTime',this.formData)
    },

    dateFocus(val){
      switch(val){
        case 'Period':
          this.formData.type = '2'
          break
        case 'month':
          this.formData.type = '3'
          break
        case 'year':
          this.formData.type = '4'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
  margin-top: 60px!important;
  margin-right: 20px!important;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  .el-radio{
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    ::v-deep .el-radio__label{
      display: flex;
      align-items: center;
      .type-span{
        /*margin-left: 8px;*/
        width: 78px;
        display: block;
        flex-shrink: 0;
      }
      .el-input{
        width: 100%!important;
      }
      .el-input__inner{
        height: 32px;
      }
      .el-input__icon{
        line-height: 32px;
      }
    }

  }
.dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;

  }
}
</style>
